import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {InformType} from '../../../../global/util/enum/InformType';
import {SearchDocument} from '../../../model/search/SearchDocument';
import {CustomDateParserFormatter} from '../../balance/view-balance/view-balance.component';
import {NgbDateStructUtil} from '../../../../global/util/NgbDateStructUtil';

@Component({
  selector: 'app-complex-document-search',
  templateUrl: './complex-document-search.component.html',
  styleUrls: ['./complex-document-search.component.css'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}
  ]
})
export class ComplexDocumentSearchComponent implements OnInit {
  public loading: boolean;
  public searchDocument: SearchDocument;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    if (!this.searchDocument) {
      this.searchDocument = new SearchDocument();
    }
  }

  public search(): void {
    this.searchDocument.dateFrom = NgbDateStructUtil.toString(this.searchDocument.dateFrom_);
    this.searchDocument.dateTo = NgbDateStructUtil.toString(this.searchDocument.dateTo_);
    this.activeModal.close({informType: InformType.Success, searchDocument: this.searchDocument});
  }

  public cancel(): void {
    this.activeModal.close({informType: InformType.Anything});
  }
}

